module.exports = __webpack_public_path__ + "u10.no2.1a331cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u10.no2.jpg
// module id = AT28
// module chunks = 0